import api from '../../api/extensions'
import { map } from 'lodash'

export function retrieve ({ dispatch }, force = false) {
  return api.retrieve(
    force,
    (data) => dispatch('RECEIVE_PRODUCTS_STATE', data),
    (response) => dispatch('SHOW_MODAL', {
      text: response.data.message,
      requestError: response.data.error,
      icon: ['uk-icon-times', 'uk-text-danger']
    })
  )
}

export function download ({ dispatch }, extensions) {
  dispatch('SHOW_MODAL', { spinner: true, block: true })
  return api.download(
    extensions,
    (downloadUrl) => {
      dispatch('SHOW_MODAL', {
        text: `The download should start shortly, otherwise click
          <a href="${downloadUrl}">here</a>.`,
        icon: ['uk-icon-cloud-download']
      })
      if (downloadUrl) {
        window.location.href = downloadUrl
      }
    },
    (response) => dispatch('SHOW_MODAL', {
      text: response.data.message,
      requestError: response.data.error,
      icon: ['uk-icon-times', 'uk-text-danger']
    })
  )
}

export function install ({ dispatch }, name) {
  dispatch('SHOW_MODAL', { spinner: true, block: true })
  return api.install(
    name,
    (installed) => {
      dispatch('MERGE_EXTENSIONS', installed)
      dispatch('SHOW_MODAL', {
        text: 'Installed succesfully',
        icon: ['uk-icon-check', 'uk-text-success']
      })
    },
    (response) => dispatch('SHOW_MODAL', {
      text: response.data.message,
      requestError: response.data.error,
      icon: ['uk-icon-times', 'uk-text-danger']
    })
  )
}

export function uninstall ({ dispatch }, extensions) {
  dispatch('SHOW_MODAL', { spinner: true, block: true })
  return api.uninstall(
    extensions,
    () => {
      dispatch('MERGE_EXTENSIONS', map(extensions, (name) =>
        ({ name, installed: false, installedVersion: '' })
      ))
      dispatch('SHOW_MODAL', {
        text: 'Uninstalled succesfully',
        icon: ['uk-icon-check', 'uk-text-success']
      })
    },
    (response) => dispatch('SHOW_MODAL', {
      text: response.data.message,
      requestError: response.data.error,
      icon: ['uk-icon-times', 'uk-text-danger']
    })
  )
}

export function toggle ({ dispatch, state }, extensions) {
  return api.toggle(
    extensions,
    (installed) => dispatch('MERGE_EXTENSIONS', installed),
    (response) => dispatch('SHOW_MODAL', {
      text: response.data.message,
      requestError: response.data.error,
      icon: ['uk-icon-times', 'uk-text-danger']
    })
  )
}



/** WEBPACK FOOTER **
 ** ./src/vuex/actions/extensions.js
 **/